import { defaultState } from './defaultState'
import { SlideDeck, SlidesStatus, SlidesObject } from '../../../lib/slides/types'
import { slidesTypes } from '../../actions/slides/slidesTypes'
import { ReduxAction } from '../reducerType'

export default function (state: SlidesObject = defaultState, { type, payload }: ReduxAction): any {

  switch (type) {

    case slidesTypes.SET_SLIDE_DECKS:

      const slideDecks: SlideDeck[] = payload || []
      const sortedSlideDecks = slideDecks.sort((a, b) => b.timeStamp.localeCompare(a.timeStamp))
      const mostRecentSlideDeck = sortedSlideDecks[0]
      let activeDeckId

      if (mostRecentSlideDeck && mostRecentSlideDeck.status === SlidesStatus.COMPLETE) {

        activeDeckId = mostRecentSlideDeck.slidesId

      }

      return {
        ...state,
        slideDecks: slideDecks,
        activeDeck: activeDeckId || null
      }
    case slidesTypes.SET_SLIDE_POSITION:
      return { ...state, selectedSlideStep: payload.selectedSlideStep, selectedSlide: payload.selectedSlide }
    case slidesTypes.UPLOAD_STARTED:
      return { ...state, isUploading: true, uploadProgress: 0, hasError: false, pendingSlidesId: null, error: null, pendingFile: payload }
    case slidesTypes.UPLOAD_PROGRESS:
      return { ...state, isUploading: true, uploadProgress: payload }
    case slidesTypes.UPLOAD_ENDED:
      return { ...state, isUploading: false, uploadProgress: 0, pendingSlidesId: payload }
    case slidesTypes.CANCEL_TOKEN_GENERATED:
      return { ...state, cancelToken: payload }
    case slidesTypes.UPLOAD_CANCELLED:
      return { ...state, cancelToken: null, isUploading: false, uploadProgress: 0 }
    case slidesTypes.PROCESSING_FAILED:
      return { ...state, isProcessing: false, processingProgress: 0, hasError: true, error: payload, pendingSlidesId: null }
    case slidesTypes.PROCESSING_ENDED:
      return { ...state, isProcessing: false, processingProgress: 0, pendingSlidesId: null }
    case slidesTypes.PROCESSING_PROGRESS:
      return { ...state, isProcessing: true, processingProgress: payload }
    case slidesTypes.SET_FEATURE_IMAGE:
      return { ...state, setAsFeatureImage: true }
    case slidesTypes.UNSET_FEATURE_IMAGE:
      return { ...state, setAsFeatureImage: false }
    case slidesTypes.FEATURE_IMAGE_REQUESTED:
      return { ...state, featureImageRequested: payload }
    case slidesTypes.FEATURE_IMAGE_REQUEST_COMPLETED:
      return { ...state, featureImageRequested: null }
    case slidesTypes.SET_ACTIVE_DECK:
      return { ...state, activeDeck: payload }
    case slidesTypes.SET_PENDING_SLIDES_ID:
      return { ...state, pendingSlidesId: payload }
    case slidesTypes.SHOW_SLIDES_CONFIRM_MODAL:
      return { ...state, showSlidesRemoveConfirmModal: true }
    case slidesTypes.HIDE_SLIDES_CONFIRM_MODAL:
      return { ...state, showSlidesRemoveConfirmModal: false }
    case slidesTypes.SET_API_VERSION:
      return { ...state, apiVersion: payload }
    default:
      return state

  }

}
